import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", as: Tag = motion.span }) => (
  <span className={`block overflow-hidden ${className}`}>
    <Tag
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </Tag>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ y, opacity: 0 }}
    whileInView={{ y: 0, opacity: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] text-nexa-red ${className}`} data-testid="section-tag">
    {children}
  </p>
);
